import { createSlice } from "@reduxjs/toolkit";

export interface LiveSessionQuestion {
  language: string;
  timeup: boolean;
  answers: {
    id: number;
    text: string;
    isCorrect: boolean;
  }[];
}

export interface LiveSessionStudentAnswer {
  studentId: number;
  studentName: string;
  answers: number[];
}

export interface LiveSessionStudentDevices {
  studentId: number;
  deviceId: number;
  serverTimestamp: number;
}

interface LiveSessionI {
  students: number[];
  studentsNames: { [id: number]: string };
  hands_raised: number[];
  allowed_to_speak: number[];
  active_mics: number[];
  kickedOut: number[];
  chat: {
    senderId: number;
    senderName: string;
    text: string;
    timestamp: number;
  }[];
  question: LiveSessionQuestion | null;
  studentsAnswers: LiveSessionStudentAnswer[];
  studentsDevices: LiveSessionStudentDevices[];
}

const initialState: LiveSessionI = {
  students: [],
  studentsNames: [],
  hands_raised: [],
  allowed_to_speak: [],
  active_mics: [],
  kickedOut: [],
  chat: [],
  question: null,
  studentsAnswers: [],
  studentsDevices: [],
};

export const liveSessionSlice = createSlice({
  name: "liveSession",
  initialState,
  reducers: {
    setLiveSessionState: (state, action) => {
      return (state = action.payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLiveSessionState } = liveSessionSlice.actions;

export default liveSessionSlice.reducer;
